module.exports = __webpack_public_path__ + "img/deleteIcon.6ca55637.svg";